module.exports = __webpack_public_path__ + "img/frontend-development.ddaa7625.png";